(function() {
    var module;

    try {
        // Get current templates module
        module = angular.module('templates');
    } catch (error) {
        // Or create a new one
        module = angular.module('templates', []);
    }

    module.run(["$templateCache", function($templateCache) {
        $templateCache.put('app/modules/organization/timeSeries.tpl.html', '<div class=\"portlet light\">\n    <div class=\"portlet-body\">\n        <div chart=\"yearsChartOptions\" server-request=\"yearsSR\"></div>\n    </div>\n</div>\n');
    }]);
})();